var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "professionalForm" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.saveProfessionalForm.apply(null, arguments)
                },
                reset: function ($event) {
                  $event.preventDefault()
                  return _vm.clearForm.apply(null, arguments)
                },
              },
            },
            [
              _vm.isEdit
                ? _c(
                    "b-alert",
                    {
                      staticClass: "mb-2",
                      attrs: { variant: _vm.kycVariant, show: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "alert-body d-flex justify-content-between align-items-center flex-wrap",
                        },
                        [
                          _c(
                            "span",
                            [
                              _c("strong", [_vm._v("Habilitação:")]),
                              _vm._v(" " + _vm._s(_vm.kycLabel) + " "),
                              _vm.professional.kyc_notes
                                ? [
                                    _vm._v(
                                      " — " + _vm._s(_vm.professional.kyc_notes)
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm.canSubmitForReview
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-primary",
                                  },
                                  on: { click: _vm.submitForReview },
                                },
                                [_vm._v(" Enviar para análise ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "CPF", "label-for": "document" } },
                      [
                        _c("validation-provider", {
                          attrs: { name: "CPF", rules: "required|cpf" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["###.###.###-##"],
                                        expression: "['###.###.###-##']",
                                      },
                                    ],
                                    staticClass: "required",
                                    attrs: {
                                      id: "document",
                                      state: errors.length > 0 ? false : null,
                                      disabled: _vm.isEdit,
                                      name: "professional-document",
                                    },
                                    model: {
                                      value: _vm.professional.document,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.professional,
                                          "document",
                                          $$v
                                        )
                                      },
                                      expression: "professional.document",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                  _vm.isEdit
                                    ? _c(
                                        "small",
                                        { staticClass: "text-muted d-block" },
                                        [
                                          _vm._v(
                                            " O CPF identifica o cadastro e não pode ser alterado. "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Nome completo",
                          "label-for": "company_name",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "Nome completo", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "company_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "company_name",
                                    },
                                    model: {
                                      value: _vm.professional.company_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.professional,
                                          "company_name",
                                          $$v
                                        )
                                      },
                                      expression: "professional.company_name",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                  _c(
                                    "small",
                                    { staticClass: "text-muted d-block" },
                                    [
                                      _vm._v(
                                        "Nome civil, como no documento. É o que vai ao gateway de pagamento."
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Nome público",
                          "label-for": "trading_name",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "Nome público", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "trading_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "trading_name",
                                    },
                                    model: {
                                      value: _vm.professional.trading_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.professional,
                                          "trading_name",
                                          $$v
                                        )
                                      },
                                      expression: "professional.trading_name",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                  _c(
                                    "small",
                                    { staticClass: "text-muted d-block" },
                                    [
                                      _vm._v(
                                        "Como o profissional aparece na busca e na página dele."
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c("validation-provider", {
                      attrs: {
                        name: "Data de nascimento",
                        rules: "required|min_age",
                        slim: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Data de nascimento",
                                    "label-for": "birthdate",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "birthdate",
                                      type: "date",
                                      name: "birthdate",
                                    },
                                    model: {
                                      value: _vm.professional.birthdate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.professional,
                                          "birthdate",
                                          $$v
                                        )
                                      },
                                      expression: "professional.birthdate",
                                    },
                                  }),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state:
                                          validationContext.errors.length === 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(validationContext.errors[0]) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
              !_vm.isEdit
                ? _c("div", { staticClass: "vx-row" }, [
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-1/2 w-full" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "E-mail de acesso",
                              "label-for": "email",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "E-mail",
                                rules: "required|email",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          staticClass: "required",
                                          attrs: {
                                            id: "email",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "email",
                                          },
                                          model: {
                                            value: _vm.professional.email,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.professional,
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression: "professional.email",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted d-block" },
                                          [
                                            _vm._v(
                                              " Se o CPF ou o e-mail já existirem, a conta é reaproveitada. "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                807266244
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-1/2 w-full" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Telefone", "label-for": "phone" },
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: ["(##) ####-####", "(##) #####-####"],
                                  expression:
                                    "['(##) ####-####', '(##) #####-####']",
                                },
                              ],
                              attrs: { id: "phone", name: "phone" },
                              model: {
                                value: _vm.professional.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.professional, "phone", $$v)
                                },
                                expression: "professional.phone",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Formas de atendimento" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "mb-1",
                            model: {
                              value: _vm.professional.serves_in_person,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.professional,
                                  "serves_in_person",
                                  $$v
                                )
                              },
                              expression: "professional.serves_in_person",
                            },
                          },
                          [_vm._v(" No espaço do profissional ")]
                        ),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "mb-1",
                            model: {
                              value: _vm.professional.serves_at_home,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.professional,
                                  "serves_at_home",
                                  $$v
                                )
                              },
                              expression: "professional.serves_at_home",
                            },
                          },
                          [_vm._v(" No endereço do aluno (domicílio) ")]
                        ),
                        _c(
                          "b-form-checkbox",
                          {
                            model: {
                              value: _vm.professional.serves_online,
                              callback: function ($$v) {
                                _vm.$set(_vm.professional, "serves_online", $$v)
                              },
                              expression: "professional.serves_online",
                            },
                          },
                          [_vm._v(" Online ")]
                        ),
                        _c(
                          "small",
                          { staticClass: "text-muted d-block mt-1" },
                          [
                            _vm._v(
                              " Quem atende online aparece em qualquer busca por proximidade. "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.canApprove
                  ? _c(
                      "div",
                      { staticClass: "vx-col sm:w-1/2 w-full" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: _vm.$t("legal_entity.status"),
                              "label-for": "status",
                            },
                          },
                          [
                            _c("b-form-radio-group", {
                              attrs: {
                                id: "status",
                                name: "status",
                                options: _vm.statusOptions,
                              },
                              model: {
                                value: _vm.professional.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.professional, "status", $$v)
                                },
                                expression: "professional.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "description",
                          label: "Sobre o profissional",
                          "label-for": "description",
                        },
                      },
                      [
                        _c("complex-editor", {
                          attrs: {
                            editor_data: _vm.professional.description,
                            "auto-open": true,
                          },
                          on: {
                            "update:editor_data": function ($event) {
                              return _vm.$set(
                                _vm.professional,
                                "description",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm.isEdit
                ? _c(
                    "b-form-row",
                    { staticClass: "justify-center" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "label",
                            { staticClass: "w-full text-left block" },
                            [_vm._v("Foto de perfil")]
                          ),
                          _c("image-upload", {
                            key: _vm.logoUploadURL,
                            staticClass:
                              "border-faint-grey border-solid border p-2 rounded-lg",
                            attrs: {
                              maxHeight: "140px",
                              maxWidth: "140px",
                              hint: "Tamanho recomendado: 800×1000px (retrato, proporção 4:5), rosto centralizado e próximo ao topo — a foto é cortada verticalmente nos cards de busca e no perfil público.",
                              uploadUrl: _vm.logoUploadURL,
                            },
                            on: { "upload-complete": _vm.uploadLogoSuccess },
                            model: {
                              value: _vm.imageData,
                              callback: function ($$v) {
                                _vm.imageData = $$v
                              },
                              expression: "imageData",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "vx-row mt-2 mb-2" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full flex gap-2 justify-end" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "ripple",
                            rawName: "v-ripple.400",
                            value: "rgba(255, 255, 255, 0.15)",
                            expression: "'rgba(255, 255, 255, 0.15)'",
                            modifiers: { 400: true },
                          },
                        ],
                        staticClass: "float-right",
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.validateForm,
                          type: "submit",
                        },
                      },
                      [_vm._v(" Salvar ")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "float-right",
                        attrs: { type: "reset", variant: "outline-secondary" },
                      },
                      [_vm._v(" Limpar ")]
                    ),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "ripple",
                            rawName: "v-ripple.400",
                            value: "rgba(255, 255, 255, 0.15)",
                            expression: "'rgba(255, 255, 255, 0.15)'",
                            modifiers: { 400: true },
                          },
                        ],
                        staticClass: "mr-2 float-right",
                        attrs: { variant: "outline-secondary" },
                        on: { click: _vm.goBack },
                      },
                      [_vm._v(" Voltar ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }